/**
 * Sort options for the RFx list pages.
 *
 * Restored from the pre-PRO-637 `src/pages/RFQ/RFQ/RFQ.js` `sortedData` array
 * (@ origin/staging:33-54). PRO-637 replaced this four-option dropdown with a
 * binary asc/desc toggle, which dropped "Last Activity" and "Date Created" and
 * changed the default. This file restores the original contract verbatim.
 *
 * `value` is the wire value sent as the `sort` query param. The API resolves it
 * case-insensitively against `IsSortableModel::$sorting` (ASC / DESC / CREATED /
 * LAST_ACTIVITY), so all four are already supported server-side — no API change
 * was needed for the sort itself.
 *
 * `name` is the dropdown item label; `sort` is the collapsed button label.
 */
export type RfxSortValue = "asc" | "desc" | "last_activity" | "created";

export interface RfxSortOption {
	/** Dropdown item label. */
	name: string;
	/** Collapsed button label ("Sort by: …"). */
	sort: string;
	/** Wire value for the `sort` query param. */
	value: RfxSortValue;
}

export const RFX_SORT_OPTIONS: RfxSortOption[] = [
	{
		name: "Sort Alphabetically (A to Z)",
		value: "asc",
		sort: "Sort by: A to Z",
	},
	{
		name: "Sort Alphabetically (Z to A)",
		value: "desc",
		sort: "Sort by: Z to A",
	},
	{
		name: "Sort by Last Activity",
		value: "last_activity",
		sort: "Sort by: Activity",
	},
	{
		name: "Sort by Date Created",
		value: "created",
		sort: "Sort by: Date",
	},
];

/**
 * Default sort — "Last Activity", matching legacy `RFQ.js`'s
 * `useState(sortedData[2])`. PRO-637 regressed this to `undefined` (which the
 * API falls back to `asc` for), so lists came back alphabetical instead of
 * most-recently-touched-first.
 */
export const RFX_DEFAULT_SORT: RfxSortOption = RFX_SORT_OPTIONS[2];
